import { Button, Spinner } from '@grupoboticario/flora-react'
import { HeartFillIcon, HeartOutlineIcon } from '@grupoboticario/flora-react-icons'
import { useEffect, useMemo, useState } from 'react'
import { IProduct } from '../../../@interfaces'
import { useFavorites } from '@grupoboticario/barril-del-chavo'

interface IToggleFavoritesItemProps {
  product: IProduct
}

export const ToggleFavoritesItem = ({ product }: IToggleFavoritesItemProps) => {
  const [loading, setLoading] = useState(false)
  const [isFavoritesFull, setIsFavoritesFull] = useState(false)
  const [isItemInFavorites, setIsItemInFavorites] = useState(false)

  const favorites = useFavorites()

  const label = !isItemInFavorites ? 'Salvar como Favorito' : 'Remover dos Favoritos'

  const icon = useMemo(() => {
    if (loading) {
      return <Spinner />
    }

    return isItemInFavorites ? <HeartFillIcon /> : <HeartOutlineIcon />
  }, [isItemInFavorites, loading])

  const handleToggleItem = async () => {
    const { sku, organization } = product

    try {
      setLoading(true)
      await favorites.toggleFavorite({ sku, organization: organization.slugName })
    } catch {
      /** do nothing */
    } finally {
      setLoading(false)
    }

    const itemInFavorites = await favorites.isFavorited(product.sku)
    setIsItemInFavorites(itemInFavorites)
  }

  useEffect(() => {
    favorites.isFull().then(setIsFavoritesFull)
    favorites.isFavorited(product.sku).then(setIsItemInFavorites)
  }, [product.sku, favorites])

  if (!favorites.isFavoritesEnabled) {
    return null
  }

  return (
    <Button
      data-autotagging-flora-section="container-wishlist"
      autotagging-flora="on"
      data-flora-text={label}
      aria-label={label}
      size="small"
      variant="ghost"
      onClick={handleToggleItem}
      disabled={(isFavoritesFull && !isItemInFavorites) || loading}
      css={{
        height: '100%',
      }}
    >
      {icon}
    </Button>
  )
}
